export const cutFileExtension = (fileName: string) =>
  fileName.replace(/\.[^.]*$/, '')
